/**
 * Ahnlight Platform Common & Landing Page Scripts
 */

let landingInitialized = false;

function initLandingPage() {
    // Prevent multiple initializations on the same page load
    // However, with Turbo, we need to re-bind elements if they are new
    
    const header = document.getElementById('header');
    const fullMenu = document.getElementById('fullMenu');
    const menuOpenBtn = document.getElementById('menuOpen');
    const menuCloseBtn = document.getElementById('menuClose');

    if (!header || !fullMenu || !menuOpenBtn || !menuCloseBtn) return;

    // Remove old listeners if any (by replacing elements or using a flag)
    // For simplicity in a script like this, we can check a data attribute
    if (header.dataset.initialized) return;
    header.dataset.initialized = "true";

    console.log("Initializing Ahnlight Platform UI...");

    // Unified scroll handler for performance
    const handleScroll = () => {
        const scrollPos = window.scrollY;

        // 1. Header scroll effect
        if (scrollPos > 50) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }

        // 2. Reveal animations
        const reveals = document.querySelectorAll('.reveal:not(.active)');
        reveals.forEach(el => {
            const windowHeight = window.innerHeight;
            const elementTop = el.getBoundingClientRect().top;
            const elementVisible = 100;

            if (elementTop < windowHeight - elementVisible) {
                el.classList.add('active');
            }
        });

        // 3. Parallax effect for hero background
        const heroBg = document.querySelector('.hero-bg');
        if (heroBg) {
            heroBg.style.transform = `scale(${1.05 + scrollPos * 0.0001}) translateY(${scrollPos * 0.1}px)`;
        }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Run once on init
    handleScroll();

    // Full-page Menu Toggle
    menuOpenBtn.addEventListener('click', () => {
        fullMenu.classList.add('active');
        document.body.style.overflow = 'hidden'; 
    });

    menuCloseBtn.addEventListener('click', () => {
        fullMenu.classList.remove('active');
        document.body.style.overflow = 'auto';
    });

    // Close menu on link click
    const menuLinks = fullMenu.querySelectorAll('a');
    menuLinks.forEach(link => {
        link.addEventListener('click', () => {
            fullMenu.classList.remove('active');
            document.body.style.overflow = 'auto';
        });
    });
}

// Support both standard page load and Turbo
document.addEventListener('DOMContentLoaded', initLandingPage);
if (window.Turbo) {
    document.addEventListener('turbo:load', initLandingPage);
} else {
    document.addEventListener('turbolinks:load', initLandingPage);
}
